/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementIncidentManagementConfigurationMappingForAlerts extends models.JiraServiceManagementIncidentManagementConfigurationMapping {
    getFixupPrototypeFunction() { return JiraServiceManagementIncidentManagementConfigurationMappingForAlerts.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementIncidentManagementConfigurationMappingForAlerts>): JiraServiceManagementIncidentManagementConfigurationMappingForAlerts {
        let obj = Object.assign(new JiraServiceManagementIncidentManagementConfigurationMappingForAlerts(), model);
        JiraServiceManagementIncidentManagementConfigurationMappingForAlerts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementIncidentManagementConfigurationMappingForAlerts>): JiraServiceManagementIncidentManagementConfigurationMappingForAlerts {
        if (!model) return null;
        return JiraServiceManagementIncidentManagementConfigurationMappingForAlerts.newInstance(<JiraServiceManagementIncidentManagementConfigurationMappingForAlerts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMappingForAlerts) {
        if (!obj) return;

        models.JiraServiceManagementIncidentManagementConfigurationMappingForAlerts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMappingForAlerts): boolean {
        if (models.JiraServiceManagementIncidentManagementConfigurationMapping.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementIncidentManagementConfigurationMappingForAlerts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Alerts Description
     */
    value: models.DescriptionAttributeForItsmAlert;

    value_direct: string;

}
